import { BlockListSection, DetailSection, Section } from '@sr/types';
import React from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { Box } from '../../ui';
import SidebarRow from './SidebarRow';

type Props = {
  section: DetailSection | BlockListSection;
  closeSidebar?: () => void;
};

const SectionItems = ({ section, closeSidebar }: Props) => (
  <Droppable droppableId={section.sectionId} type="SECTION_ITEM">
    {(provided) => (
      <Box
        ref={provided.innerRef}
        {...provided.droppableProps}
        sx={{
          ':hover .dragItem': {
            opacity: 1,
          },
        }}
      >
        {(section.itemsOrder || []).map((itemId, index) => {
          const item = section.items && section.items[itemId];
          if (!item) return false;
          if (item.type === 'detail' || item.type === 'block-list') {
            return (
              <Draggable
                draggableId={itemId}
                index={index}
                // @ts-ignore
                type="SECTION_ITEM"
                key={itemId}
              >
                {(provided) => (
                  <Box
                    variant="containers.indentedCell"
                    sx={{ display: 'flex' }}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                  >
                    <SidebarRow
                      id={item.id}
                      title={
                        (item.type === 'detail' ? item.title : item.primary) ||
                        'Untitled'
                      }
                      isSectionItem={true}
                      dragHandleProps={provided.dragHandleProps}
                      closeSidebar={closeSidebar}
                    />
                  </Box>
                )}
              </Draggable>
            );
          } else {
            return false;
          }
        })}
        {provided.placeholder}
      </Box>
    )}
  </Droppable>
);

export default SectionItems;
